import React from 'react';
import { ProductGrid } from 'scy/ProductGrid';
import ProductGridItem from './GridItem';

export default function Grid({
  products,
  isCheckout,
  className,
  itemClassName
}) {
  return (
    <ProductGrid className={className}>
      {products.map((product, idx) => (
        <ProductGridItem
          key={idx + '-' + product.sku_id}
          product={product}
          isCheckout={isCheckout}
          includeItemProps
          className={itemClassName}
          raiseOnHover
        />
      ))}
    </ProductGrid>
  );
}
